/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataCutDisplayMode {
    RAW = 'raw',
    AGED_AND_ADJUSTED = 'agedAndAdjusted',
}
